import { render, staticRenderFns } from "./UsersSwitch.vue?vue&type=template&id=0f7e3d0f&scoped=true&"
import script from "./UsersSwitch.vue?vue&type=script&lang=js&"
export * from "./UsersSwitch.vue?vue&type=script&lang=js&"
import style0 from "./UsersSwitch.vue?vue&type=style&index=0&id=0f7e3d0f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e3d0f",
  null
  
)

export default component.exports